export default __webpack_public_path__ + "static/media/RAJ_2246.c5f90865.jpg";